export const mobileViewStyle = {
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: '100%',
  margin: 0,
  borderRadius: 0,
};